import { useCallback, useRef } from 'react';
import { DatahubEntity, SeekedAction } from 'src/interfaces/Datahub';
import { EVENT_TYPES } from 'src/interfaces/enums';
import ApplicationService from 'src/services/ApplicationService';
import useTracking from '../useTracking';

export default function useSeek() {
  const { trackDatahub, trackProgress } = useTracking();
  const startTimeRef = useRef(0);

  const onSeekInit = useCallback(() => {
    startTimeRef.current = ApplicationService.player?.currentTime || 0;
    ApplicationService.player?.triggerEvent(EVENT_TYPES.SEEK_INIT);
    trackProgress();
  }, [trackProgress]);

  const onSeekEnded = useCallback(() => {
    ApplicationService.player?.triggerEvent(EVENT_TYPES.SEEK_ENDED);
    ApplicationService.player?.setUserActive(true);
    trackDatahub(DatahubEntity.SEEKED, SeekedAction.MEASURE, {
      startTime: startTimeRef.current,
      endTime: ApplicationService.player?.currentTime,
    });
  }, [trackDatahub]);

  return {
    onSeekInit,
    onSeekEnded,
  };
}
